module.exports = __webpack_public_path__ + "static/media/06.134289f9.png";